<ng-template #orderDetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">RMA# {{orderdetails.header.orderno}}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body" *ngIf="orderdetails">

		<!-- Header: addresses + order meta -->
		<div class="row mb-3">
			<div class="col-md-4">
				<small class="text-muted text-uppercase font-weight-bold">Bill To</small>
				<div [innerHTML]="orderdetails.header.billto"></div>
			</div>
			<div class="col-md-4">
				<small class="text-muted text-uppercase font-weight-bold">Pickup / Ship To</small>
				<div [innerHTML]="orderdetails.header.shipto"></div>
			</div>
			<div class="col-md-4">
				<small class="text-muted text-uppercase font-weight-bold">Credit Info</small>
				<table class="table table-sm table-borderless mb-0">
					<tbody>
						<tr *ngIf="orderdetails.header.from_order">
							<td class="p-0 text-muted">Source Invoice#</td>
							<td class="p-0">{{orderdetails.header.from_order}}</td>
						</tr>
						<tr *ngIf="orderdetails.header.customerref">
							<td class="p-0 text-muted">PO#</td>
							<td class="p-0">{{orderdetails.header.customerref}}</td>
						</tr>
						<tr *ngIf="orderdetails.header.freightcost > 0">
							<td class="p-0 text-muted">Freight</td>
							<td class="p-0">{{orderdetails.header.freightcost | currency}}</td>
						</tr>
						<tr *ngIf="orderdetails.header.shippername">
							<td class="p-0 text-muted">Ship Via</td>
							<td class="p-0">{{orderdetails.header.shippername}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<ng-container *ngIf="orderdetails.header.notes || orderdetails.header.comments">
			<div class="row mb-2">
				<div class="col-md-6" *ngIf="orderdetails.header.notes">
					<small class="text-muted text-uppercase font-weight-bold">Notes</small>
					<div>{{orderdetails.header.notes}}</div>
				</div>
				<div class="col-md-6" *ngIf="orderdetails.header.comments">
					<small class="text-muted text-uppercase font-weight-bold">Dispatch Note</small>
					<div>{{orderdetails.header.comments}}</div>
				</div>
			</div>
		</ng-container>

		<hr class="mt-1 mb-2">

		<!-- Line items -->
		<div class="table-responsive">
			<table class="table table-sm">
				<thead>
					<tr>
						<th>ITEM</th>
						<th>DESC</th>
						<th class="text-center">ORDERED</th>
						<th class="text-center">INVOICED</th>
						<th class="text-center">OUTSTANDING</th>
						<th class="text-right">PRICE</th>
						<th class="text-right">DISCOUNT</th>
						<th class="text-right">TOTAL</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of orderdetails.details">
						<td>{{item.stkcode}}</td>
						<td>{{item.description}}</td>
						<td class="text-center">{{item.ordered}}</td>
						<td class="text-center">{{item.qtyinvoiced}}</td>
						<td class="text-center">{{item.ordered - item.qtyinvoiced}}</td>
						<td class="text-right">{{item.unitprice | currency}}</td>
						<td class="text-right">{{item.discountpercent | percent}}</td>
						<td class="text-right">{{item.discountprice * item.ordered | currency}}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr *ngFor="let t of orderdetails.saved_totals">
						<td colspan="6"></td>
						<td class="text-right font-weight-bold">{{t.title}}:</td>
						<td class="text-right">{{t.text | currency}}</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #pgsReceiptDetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="pgs-receipt-title">
			PGS Receipt {{ selectedPgsReceipt?.tpl3pl_received?.receipt_no }} · RMA {{ selectedPgsReceipt?.orderno }}
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body" *ngIf="selectedPgsReceipt?.tpl3pl_received as receipt">
		<div class="alert mb-3" [ngClass]="receiptAlertClass(receipt)">
			<strong>{{ receiptHeadline(receipt) }}</strong>
			<span class="ml-2" *ngIf="hasReceiptProgress(receipt)">
				RMA {{ receipt.ordered_qty }} · Received {{ receipt.received_qty }} · Credited {{ receipt.credited_qty }}
				· Pending {{ receipt.pending_qty }} ({{ receipt.receipt_line_count }} PGS lines)
			</span>
			<span *ngIf="receipt.receipt_date"> · {{ receipt.receipt_date | date:'shortDate' }}</span>
		</div>
		<div class="alert alert-info mb-3" *ngIf="receipt.followup">
			<strong>Follow-up pickup requested</strong> — PGS locked the original inbound once it started
			receiving, so the leftover {{ receipt.pending_qty }} unit{{ receipt.pending_qty === 1 ? '' : 's' }}
			{{ receipt.followup.success ? 'was' : 'attempted to be' }} sent under a new pickup,
			<strong>{{ receipt.followup.purchase_order_no }}</strong>
			<span *ngIf="!receipt.followup.success" class="text-danger"> (send failed — will retry)</span>.
		</div>
		<div class="table-responsive">
			<table class="table table-sm table-striped">
				<thead>
					<tr>
						<th>RMA SKU / DESCRIPTION</th>
						<th>PGS SCANNED SKU</th>
						<th class="text-center">ON RMA</th>
						<th class="text-center">RECEIVED</th>
						<th class="text-center">PENDING</th>
						<th>RESULT</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let line of receipt.lines" [class.table-warning]="+line.needs_review === 1">
						<td>
							<div>{{ line.rma_itemcode || (line.orderlineno ? 'Matched RMA item' : 'Not on RMA') }}</div>
							<small class="text-muted" *ngIf="line.description">{{ line.description }}</small>
						</td>
						<td>
							<div>{{ line.itemcode || '—' }}</div>
							<small class="text-muted" *ngIf="line.pgs_description">{{ line.pgs_description }}</small>
						</td>
						<td class="text-center">{{ line.qty_on_rma == null ? '—' : line.qty_on_rma }}</td>
						<td class="text-center font-weight-bold">{{ line.qty_received }}</td>
						<td class="text-center font-weight-bold">{{ line.qty_pending == null ? '—' : line.qty_pending }}</td>
						<td>
							<span *ngIf="+line.needs_review !== 1 && line.qty_pending === 0" class="text-success">Received</span>
							<span *ngIf="+line.needs_review !== 1 && line.qty_pending > 0" class="text-muted">Pending</span>
							<span *ngIf="+line.needs_review === 1" class="text-warning font-weight-bold">{{ line.review_reason }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</ng-template>

<div class="oc-wrap" [ngStyle]="themeVars">

	<!-- ── Floating accent icon ─────────────────────────────────────────────── -->
	<div class="oc-icon-badge">
		<i class="material-icons">account_balance_wallet</i>
	</div>

	<!-- ── Header ───────────────────────────────────────────────────────────── -->
	<div class="oc-header">
		<div class="oc-title-group">
			<span class="oc-title">Open RMAs</span>
			<span class="oc-subtitle" *ngIf="statCount">{{ statCount }} open RMA{{ statCount === 1 ? '' : 's' }}</span>
		</div>

		<div class="oc-actions">
			<a class="oc-icon-btn" href="{{returnSheetLink}}&format=xls" title="Export Excel">
				<i class="fa fa-file-excel-o"></i>
			</a>
			<a class="oc-icon-btn" href="{{returnSheetLink}}&format=pdf" title="Export PDF">
				<i class="fa fa-file-pdf-o"></i>
			</a>
			<button class="oc-icon-btn" (click)="loadData()" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
			<button class="oc-icon-btn"
					[class.oc-icon-btn--active]="showFilters"
					(click)="showFilters = !showFilters"
					title="Filters">
				<i class="material-icons">tune</i>
			</button>
		</div>
	</div>

	<!-- ── Summary stats ────────────────────────────────────────────────────── -->
	<div class="oc-stats" *ngIf="statCount && !loading">
		<div class="oc-stat">
			<span class="oc-stat-val">{{ statTotal | currency }}</span>
			<span class="oc-stat-lbl">Total Open Value</span>
		</div>
		<div class="oc-stat">
			<span class="oc-stat-val">{{ statCount }}</span>
			<span class="oc-stat-lbl">Open RMAs</span>
		</div>
		<div class="oc-stat">
			<span class="oc-stat-val">{{ statLargest | currency }}</span>
			<span class="oc-stat-lbl">Largest Credit</span>
		</div>
	</div>

	<!-- ── Filter drawer ────────────────────────────────────────────────────── -->
	<div class="oc-filters" *ngIf="showFilters">
		<mat-form-field appearance="outline" class="oc-field">
			<mat-label>Warehouse</mat-label>
			<mat-select [formControl]="defaultlocation">
				<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
					{{ loc.locationname }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="oc-field">
			<mat-label>Item Search</mat-label>
			<input matInput [formControl]="searchInputItems" (input)="searchItems()" placeholder="Search...">
			<span matSuffix>
				<button mat-icon-button (click)="searchItems()">
					<mat-icon>search</mat-icon>
				</button>
			</span>
		</mat-form-field>

		<mat-form-field appearance="outline" class="oc-field">
			<mat-label>Order Search</mat-label>
			<input matInput [formControl]="searchInput" (input)="onInput(searchInput.value)" placeholder="Search...">
			<span matSuffix>
				<button mat-icon-button (click)="search()">
					<mat-icon>search</mat-icon>
				</button>
			</span>
		</mat-form-field>
	</div>

	<!-- ── Loading ──────────────────────────────────────────────────────────── -->
	<div class="oc-loading" *ngIf="loading">
		<svg class="spinner" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<!-- ── Empty (no data returned) ─────────────────────────────────────────── -->
	<div class="oc-empty" *ngIf="!loading && !openOrderData">
		No Open RMAs
	</div>

	<!-- ── Body / table ─────────────────────────────────────────────────────── -->
	<div class="oc-body" [class.d-none]="loading">
		<div class="oc-table-wrap" [ngClass]="openOrderData ? '' : 'd-none'">
			<table mat-table class="oc-table" [dataSource]="openorders" matSort (matSortChange)="announceSortChange($event)">

				<ng-container matColumnDef="orderno">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> RMA#</th>
					<td mat-cell *matCellDef="let tran">

						<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
							<mat-icon>more_vert</mat-icon>
						</button>
						<mat-menu #menu="matMenu">
							<button mat-menu-item (click)="viewOrder(tran.orderno, orderDetails)">
								<mat-icon>visibility</mat-icon>
								<span>View</span>
							</button>

							<button mat-menu-item (click)="loadOrder(tran)">
								<mat-icon>edit</mat-icon>
								<span>Edit</span>
							</button>
							<ng-container *ngIf="config.env.package == 'tires'">
								<a *ngIf="!usePrintConnect()" href="{{pickinglink}}{{tran.orderno}}" mat-menu-item>
									<mat-icon>print</mat-icon>
									<span>PDF</span>
								</a>
								<a *ngIf="usePrintConnect()" (click)="printCustomerCopy(tran.orderno)" mat-menu-item>
									<mat-icon>print</mat-icon>
									<span>PDF - EP</span>
								</a>
							</ng-container>
							<ng-container *ngIf="config.env.package !== 'tires'">
								<a href="{{pickinglink}}{{tran.orderno}}" mat-menu-item>
									<mat-icon>print</mat-icon>
									<span>PDF</span>
								</a>
							</ng-container>
							<!-- <button mat-menu-item [routerLink]="'/orders/pick/'+tran.orderno">
									<mat-icon>get_app</mat-icon>
									<span>Pick</span>
								</button> -->

							<button mat-menu-item [routerLink]="'/receivables/dispatch/'+tran.orderno">
								<mat-icon>description</mat-icon>
								<span> Credit Account </span>
							</button>
							<!--
								<button mat-menu-item (click)="updatePick(tran.orderno)">
									<mat-icon>done</mat-icon>
									<span>Set Picked</span>
								</button>

								<button mat-menu-item (click)="setDelivered(tran.orderno)">
									<mat-icon>local_shipping</mat-icon>
									<span>Set Delivered</span>
								</button>
								-->
							<button mat-menu-item (click)="cancelOrder(tran.orderno)">
								<mat-icon>remove</mat-icon>
								<span>Cancel</span>
							</button>

						</mat-menu>

						{{ tran.orderno }}

					</td>
				</ng-container>

				<ng-container matColumnDef="statusname">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
					<td mat-cell *matCellDef="let tran">
						<span class="order-status-pill status-{{ tran.details.orderstatusid }}" [ngStyle]="statusBadgeStyle(tran)">
							{{ statusLabel(tran) }}
							<i class="fa fa-edit status-pill-edit" (click)="toggleEdit(tran); $event.stopPropagation()" *ngIf="tran.details.orderstatusid !='50'"></i></span>

						<ng-container *ngIf="tran.edit">
							<mat-form-field appearance="outline">
								<mat-label>Status</mat-label>
								<mat-select [formControl]="order_status_edit">
									<mat-option *ngFor="let s of order_statuses" [value]="s.order_status_id">
										{{ s.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
							<button class="btn btn-sm btn-danger" (click)="saveStatusUpdate(tran)">
								<i class="fa fa-save"></i>
							</button>
						</ng-container>
					</td>
				</ng-container>
				<ng-container matColumnDef="deliverydate">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Date Wanted</th>
					<td mat-cell *matCellDef="let tran">{{ tran.deliverydate }}</td>
				</ng-container>
				<ng-container matColumnDef="from_order">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice#</th>
					<td mat-cell *matCellDef="let tran">{{ tran.from_order }}</td>
				</ng-container>
				<ng-container matColumnDef="customer">
					<th mat-header-cell *matHeaderCellDef mat-sort-header="debtorno">Customer</th>
					<td mat-cell *matCellDef="let tran">
						<a [routerLink]="'/customers/view/' + tran.debtorno" class="text-decoration-none">{{ tran.debtorno }}.{{ tran.branchcode }}</a>
					</td>
				</ng-container>
				<ng-container matColumnDef="deliverto">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Name</th>
					<td mat-cell *matCellDef="let tran">{{ tran.deliverto }}</td>
				</ng-container>
				<ng-container matColumnDef="ponumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> PO number#</th>
					<td mat-cell *matCellDef="let tran">{{ tran.ponumber }}</td>
				</ng-container>
				<ng-container matColumnDef="phoneno">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Phone#</th>
					<td mat-cell *matCellDef="let tran">{{ tran.phoneno }}</td>
				</ng-container>
				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Email</th>
					<td mat-cell *matCellDef="let tran">{{ tran.email }}</td>
				</ng-container>
				<ng-container matColumnDef="totals">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Total</th>
					<td mat-cell *matCellDef="let tran" class="oc-cell-total">{{ getTotal(tran.totals) | currency }}</td>
				</ng-container>

				<!-- PGS 360 — green/red flag shows submitted vs not; send/retry from list -->
				<ng-container matColumnDef="pgs360_rma">
					<th mat-header-cell *matHeaderCellDef style="width:72px;min-width:72px;" title="PGS 360 submission status">PGS</th>
					<td mat-cell *matCellDef="let tran" style="width:72px;min-width:72px;white-space:nowrap;text-align:center;">
						<ng-container *ngIf="pgsSendingOrderNo === tran.orderno; else pgsStatus">
							<mat-icon style="font-size:18px;vertical-align:middle;color:#1976d2;" title="Sending to PGS 360…">hourglass_top</mat-icon>
						</ng-container>
						<ng-template #pgsStatus>
							<ng-container *ngIf="pgsResultByOrder[tran.orderno] as live">
								<mat-icon style="font-size:18px;vertical-align:middle;" [style.color]="live.success ? '#2e7d32' : '#c62828'"
								          [title]="live.message || (live.success ? 'Sent to PGS 360' : 'PGS send failed')">{{ live.success ? 'flag' : 'error' }}</mat-icon>
								<button mat-icon-button style="width:22px;height:22px;line-height:22px;" title="Re-send to PGS 360"
								        (click)="sendRmaToPgs(tran.orderno, true)">
									<mat-icon style="font-size:13px;">refresh</mat-icon>
								</button>
							</ng-container>
							<ng-container *ngIf="!pgsResultByOrder[tran.orderno]">
								<ng-container *ngIf="tran.tpl3pl_pgs?.success">
									<mat-icon style="font-size:18px;vertical-align:middle;color:#2e7d32;" title="Submitted to PGS 360">flag</mat-icon>
									<!-- Once sent, this pushes the CURRENT lines to PGS (update/PUT) so edits sync. -->
									<button mat-icon-button style="width:22px;height:22px;line-height:22px;" title="Sync changes to PGS 360"
									        (click)="sendRmaToPgs(tran.orderno, true)">
										<mat-icon style="font-size:13px;">refresh</mat-icon>
									</button>
								</ng-container>
								<ng-container *ngIf="tran.tpl3pl_pgs && !tran.tpl3pl_pgs.success">
									<mat-icon style="font-size:18px;vertical-align:middle;color:#c62828;"
									          [title]="tran.tpl3pl_pgs.message || 'PGS submission failed'">error</mat-icon>
									<button mat-icon-button style="width:22px;height:22px;line-height:22px;" title="Retry PGS 360"
									        (click)="sendRmaToPgs(tran.orderno, true)">
										<mat-icon style="font-size:13px;">refresh</mat-icon>
									</button>
								</ng-container>
								<ng-container *ngIf="!tran.tpl3pl_pgs">
									<mat-icon style="font-size:18px;vertical-align:middle;color:#c62828;" title="Not submitted to PGS 360">outlined_flag</mat-icon>
									<button mat-icon-button style="width:22px;height:22px;line-height:22px;" title="Send to PGS 360"
									        (click)="sendRmaToPgs(tran.orderno)">
										<mat-icon style="font-size:13px;">send</mat-icon>
									</button>
								</ng-container>
							</ng-container>
						</ng-template>

						<!-- Confirmed received qtys from PGS (populated by the credit-receive sweep). -->
						<button *ngIf="tran.tpl3pl_received" type="button" class="btn btn-link p-0"
						        style="margin-top:2px;white-space:nowrap;text-decoration:none;"
						        [title]="receivedTooltip(tran)"
						        (click)="openPgsReceipt(tran, pgsReceiptDetails)">
							<mat-icon style="font-size:16px;vertical-align:middle;"
							          [style.color]="tran.tpl3pl_received.needs_review ? '#f9a825' : '#2e7d32'">{{ tran.tpl3pl_received.needs_review ? 'report_problem' : 'inventory_2' }}</mat-icon>
							<small style="vertical-align:middle;font-weight:600;">{{ receivedTotalQty(tran) }}</small>
							<mat-icon *ngIf="tran.tpl3pl_received.followup" style="font-size:14px;vertical-align:middle;color:#0288d1;"
							          [title]="'Leftover follow-up pickup ' + tran.tpl3pl_received.followup.purchase_order_no + (tran.tpl3pl_received.followup.success ? '' : ' (send failed — will retry)')">local_shipping</mat-icon>
						</button>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="headercolumns;sticky: true;"></tr>
				<tr mat-row *matRowDef="let row; columns: headercolumns" [ngClass]="orderMatches.includes(row.orderno) ? 'highlight-row' : ''"></tr>
			</table>
		</div>
		<mat-paginator [ngClass]="openOrderData ? '' : 'd-none'" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="select page">
		</mat-paginator>

		<!-- ── Empty (loaded, zero rows) ────────────────────────────────────── -->
		<div class="oc-empty" *ngIf="openOrderData && !openOrderData.length">
			No Open RMAs
		</div>
	</div>
</div>
